export const wait = async (timeout: number): Promise<void> =>
  new Promise((r) => window.setTimeout(r, timeout));
